__turbopack_context__.v({
  "circleAnimation": "_4qV2aa_circleAnimation",
  "root": "_4qV2aa_root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
